
<template>
  <v-select
    v-model="item.sellStatus"
    @change="setSellStatus($event)"
    style="width: 90px;"
    :items="statusOptions"
    label="Standard"
    :disabled="isDisabled"
  ></v-select>
</template>
<script>
import { EventBus } from '../../mixins'

// import advancedFormat from 'dayjs/plugin/advancedFormat';
// dayjs.extend(advancedFormat);

export default {
  props: {
    statusOptions: {
      type: Array,
      default: () => []
    },
    item: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {  
    async setSellStatus(event) {
      this.$emit('toggle-loading');
      
      if (event === 'Non renseigné') {
        event = '';
      }

      let notification = {
          type: 'success'
      };

      notification = await this.$store.dispatch('setSellState', { 
        iresaCode: this.item.iresaCode, 
        dateDepart: this.item.dateDepart, 
        status: event
      }).then((res) => {
        this.$emit('set-items-new-value', this.item.dateDepart, 'sellStatus', event), this.iresaCode;        

        return res;
      });

      this.$emit('toggle-loading');

      EventBus.$emit('show-notifications', [notification]);
    }
  }
};
</script>
